var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChalk1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 23,
    viewBox: "0 0 11 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47263 0.160852C2.60278 0.0567274 2.7645 0 2.93118 0H6.00695C6.20163 0 6.38833 0.0773364 6.52599 0.214996L10.0413 3.73035C10.179 3.86801 10.2563 4.05472 10.2563 4.2494V20.0685C10.2563 20.2706 10.1731 20.4637 10.0261 20.6024L7.69745 22.7998C7.56121 22.9284 7.38098 23 7.19366 23H0.734084C0.328683 23 4.14116e-05 22.6714 4.14116e-05 22.266V2.49965C-1.3833e-05 2.49445 -1.37747e-05 2.48926 4.14116e-05 2.48407V2.34894H0.0140566C0.0470107 2.18291 0.137082 2.02929 0.275531 1.91853L2.47263 0.160852ZM1.46813 3.22576V21.5319H6.45962V6.40637L3.49088 3.22576H1.46813ZM4.88703 2.57001L7.26562 5.11835L8.42406 4.18925L5.95247 1.71766L4.88703 2.57001ZM3.91435 1.46809H3.18867L2.82668 1.75768H3.55236L3.91435 1.46809ZM8.78826 5.77908L7.9277 6.46926V20.564L8.78826 19.7519V5.77908Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalk1);
export default __webpack_public_path__ + "static/media/chalk-1.09174ec39d1ed541273501647aae6c05.svg";
export { ForwardRef as ReactComponent };